import {
  ChakraFlex,
  DatePickerInput,
  FAIconName,
  InputGroupV2,
} from '@equip.health/ui';
import { DateTime } from 'luxon';
import { toLocalMidnight } from '~/lib/util/date.util';

interface DateRangeFilterProps {
  endDate?: string;
  id: string;
  label: string;
  minDate?: Date;
  setEndDate: (status: string) => void;
  setStartDate: (status: string) => void;
  startDate?: string;
}

const convertDateStrToDate = (d: string): Date => {
  const converted: DateTime = d && DateTime.fromISO(d, { zone: 'utc' });
  return converted && converted.isValid
    ? toLocalMidnight(converted.toJSDate())
    : null;
};

const convertDateToStr = (d: Date | null): string =>
  d ? DateTime.fromJSDate(d).toUTC().toISODate() : '';

const DateRangeFilter = ({
  endDate,
  id,
  label,
  minDate,
  setEndDate,
  setStartDate,
  startDate,
}: DateRangeFilterProps) => {
  const TOP_LEVEL_ID = `${id}__date-range-filter`;

  return (
    <InputGroupV2 id={TOP_LEVEL_ID} label={label}>
      <ChakraFlex gap="12px">
        <DatePickerInput
          defaultDate={convertDateStrToDate(startDate)}
          id={`${TOP_LEVEL_ID}__start-date`}
          leftIcon={FAIconName.arrowFromLeft}
          minDate={minDate}
          onSubmit={(date: Date | null) => setStartDate(convertDateToStr(date))}
          placeholder="Start date"
        />
        <DatePickerInput
          defaultDate={convertDateStrToDate(endDate)}
          id={`${TOP_LEVEL_ID}__end-date`}
          leftIcon={FAIconName.arrowToRightRegular}
          minDate={minDate}
          onSubmit={(date: Date | null) => setEndDate(convertDateToStr(date))}
          placeholder="End date"
        />
      </ChakraFlex>
    </InputGroupV2>
  );
};

export default DateRangeFilter;
